import React, { useState, useEffect, useRef } from 'react';
import { FiGrid, FiList, FiSearch } from 'react-icons/fi';

const MenuHeader = ({ toggle, settoggle, ref, value, onChange }) => {
  const [searchValue, setSearchValue] = useState(value);
  const debounceTimer = useRef(null);

  useEffect(() => {
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      onChange({ target: { value: searchValue } }); 
    }, 400); 

    return () => {
      clearTimeout(debounceTimer.current);
    };
  }, [searchValue]);

  return (
    <div className="menu-header menu-header-grid">
      <h4 className="menu-title">MENU</h4>

      <div className="view-toggle">
        <button
          className={`view-btn view-grid ${toggle === false ? 'active' : ''}`}
          onClick={() => settoggle(false)}
        >
          <FiGrid />
        </button>
        <button
          className={`view-btn view-list ${toggle === true ? 'active' : ''}`}
          onClick={() => settoggle(true)}
        >
          <FiList />
        </button>
      </div>

      <div className="search-bar">
        <FiSearch className="search-icon" size={22}/>
        <input
          type="search"
          placeholder="Search for menu items"
          ref={ref}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </div>
    </div>
  );
};

export default MenuHeader;
